import React from 'react'

const Technologies = () => {
    return (
        <div className="technologies">
            <h3>Języki oraz narzędzia których używam</h3>
            <h4>Języki:</h4>
            <ul>
                <li>HTML5</li>
                <li>CSS3</li>
                <li>JavaScript <s>(JQuery)</s> <b>(ReactJS)</b></li>
                <li>PHP</li>
                <li>MySQL</li>
                <li>Dart</li>
            </ul>
            <h4>Narzędzia:</h4>
            <ul>
                <li>SASS</li>
                <li>Boostrap</li>
                <li>Netlify</li>
                <li>Visual Studio Code</li>
                <li>Git</li>
                <li>Github</li>
                <li>Adobe Xd</li>
                <li>Flutter</li>
            </ul>
        </div>
    )
}

export default Technologies
